import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { isEqual } from 'lodash'
import {HOME, DASHBOARD, INVENTORY_INGESTION_HUB, DROPSHIP} from 'src/utils/constants/app-routes'
import { ERROR_PAGES } from 'src/utils/constants/common'

const LOGIN_ROUTE_NAMES = ['login', 'login_page', 'api/login'];

export default {
  name: 'common-error-page',
  props: {
    logoURL: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: ''
    }
  },

  setup(props) {
    const prevComponentName = window.localStorage.getItem('prevComponentName');
    const prevComponentParams = window.localStorage.getItem('prevComponentParams');
    const prevComponentFormat = window.localStorage.getItem('prevComponentFormat');
    const allFoundries = JSON.parse(window.localStorage.getItem('userFoundries'))
    const sessionFoundaryId = window.localStorage.getItem('sessionFoundryId')
    const rolesRaw = window.localStorage.getItem('roles');
    const userRoles = (() => {
      if (!rolesRaw) return '';
      try {
        const parsed = JSON.parse(rolesRaw);
        return Array.isArray(parsed) ? parsed.join(',') : rolesRaw;
      } catch {
        return rolesRaw;
      }
    })();
    const routeTo = ref('');
    const router = useRouter();
    const currentRouteName = ref('');
    const ufda2Status = ref(false)


    const roleToRouteMap = {
      foundrySupport: `#${HOME}`,
      bulkIngestionUser: `#${INVENTORY_INGESTION_HUB}`,
      dropShipUser: `#${DROPSHIP}`,
    };

    const showDashboard = computed(() => {
      const role = Object.keys(roleToRouteMap).find(role => userRoles?.includes(role));
      return roleToRouteMap[role] || `#${DASHBOARD}`;
    });

    // Module-based: map route names to their module's dashboard (from side nav modules)
    const MODULE_TO_DASHBOARD = [
      { routeNames: ['BundleDashboard', 'BundleSubmissionDraft', 'BundleSuccess'], dashboardName: 'BundleDashboard' },
      { routeNames: ['submissions_id', 'submissions_correct', 'submissions_details', 'released_submissions_details', 'live_submissions_correct', 'submissions_support_edit', 'submissions_support_review', 'success_submission'], dashboardName: 'home' },
      { routeNames: ['promos', 'new_promo', 'edit_promo', 'view_promo', 'success_promotion'], dashboardName: 'promos' },
      { routeNames: ['InventoryIngestionHub', 'InventoryIngestionCreate'], dashboardName: 'InventoryIngestionHub' },
      { routeNames: ['DropShip', 'UploadFlipFonts'], dashboardName: 'DropShip' },
      { routeNames: ['payment_dashboard', 'payment_accounts', 'payment_new_data_manager', 'payment_edit_data_manager', 'payment_account_error', 'success_pay'], dashboardName: 'payment_dashboard' },
      { routeNames: ['application', 'application_preview'], dashboardName: 'application' },
      { routeNames: ['earnings_report_dashboard'], dashboardName: 'earnings_report_dashboard' },
      { routeNames: ['quarterly_statements'], dashboardName: 'quarterly_statements' },
      { routeNames: ['contract', 'print_contract', 'post_contract', 'success_agreement'], dashboardName: 'contract' },
      { routeNames: ['foundry_profile', 'edit_foundry', 'success_foundry_update', 'user_permissions'], dashboardName: 'foundry_profile' },
      { routeNames: ['impersonate'], dashboardName: 'impersonate' },
      { routeNames: ['mfp-numbers'], dashboardName: 'mfp-numbers' },
      { routeNames: ['dashboard', 'home', 'dashboard_home'], dashboardName: 'dashboard' },
    ];

    const dashboardRouteName = computed(() => {
      const prevName = window.localStorage.getItem('prevComponentName');
      if (!prevName || ERROR_PAGES.includes(String(prevName)) || LOGIN_ROUTE_NAMES.includes(String(prevName))) return null;
      const module = MODULE_TO_DASHBOARD.find(m => m.routeNames.includes(prevName));
      return module ? module.dashboardName : null;
    });

    const hasDashboardRoute = computed(() => {
      const name = dashboardRouteName.value;
      return name != null && router.getRoutes().some(r => r.name === name);
    });

    const goToDashboard = () => {
      if (!hasDashboardRoute.value) return;
      router.replace({ name: dashboardRouteName.value }).catch(() => {});
    };

    const goToLandingPage = () => {
      if (prevComponentName && prevComponentParams && prevComponentFormat) {
        router.replace({
          name: prevComponentName,
          params: {
            id: prevComponentParams,
            format: prevComponentFormat
          }
        });
      } else if (prevComponentName && prevComponentParams) {
        router.replace({
          name: prevComponentName,
          params: {
            id: prevComponentParams
          }
        });
      } else {
        router.replace({ name: prevComponentName });
      }
    };

    onMounted(() => {
      currentRouteName.value = router?.currentRoute?.value?.name;
      if(allFoundries?.length && sessionFoundaryId) 
        setUfda2Status();
    });

    const setUfda2Status = () => {
      const selectedFoundry = allFoundries.find(foundry => isEqual(foundry.id, sessionFoundaryId));
      const hasUfda2 = isEqual(selectedFoundry.contractSummary,'UFDA 2');
      ufda2Status.value = hasUfda2;
    }

    return {
      prevComponentName,
      prevComponentParams,
      prevComponentFormat,
      routeTo,
      ufda2Status,
      currentRouteName,
      showDashboard,
      dashboardRouteName,
      hasDashboardRoute,
      goToLandingPage,
      goToDashboard,
      setUfda2Status
    };
  },
};
